// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'
import Mask from '/react4xp/components/Mask'
import AnimatedArrow from '/react4xp/components/AnimatedArrow'

// prop types
interface ProductBlockVerticalProps {
    blockSize: 'small' | 'medium' | 'large'
    tilt?: 'left' | 'right'
    hoverTilt?: 'left' | 'right'
    href: string
    external?: boolean
    src: string
    srcMobile: string
    alt?: string
    width?: number
    sizes?: string
    title: string
    desc: string
    className?: string
}

export default function ProductBlockVertical({
    blockSize,
    href,
    external,
    src,
    srcMobile,
    alt,
    width,
    sizes,
    title,
    desc,
    tilt,
    hoverTilt,
    className
}: ProductBlockVerticalProps) {

    // change the spacing of the box {breathing area} according to the blockSize
    const spacing: 'smaller' | 'small' | 'medium' | 'big' | undefined = 
        blockSize === 'large' ? 'medium' :
        blockSize === 'medium' ? 'small' :
        blockSize === 'small' ? 'smaller' :
        undefined

    return (
        <a
            href={href}
            target={external ? '_blank' : undefined}
            className={clsx(
                'product-block-vertical',

                // block size
                blockSize === 'large' && 'large',
                blockSize === 'medium' && 'medium',
                blockSize === 'small' && 'small',

                // tilt (rotate the image 10deg left or right)
                tilt === 'left' && 'tilt-left',
                tilt === 'right' && 'tilt-right',
                hoverTilt === 'left' && 'hover-tilt-left',
                hoverTilt === 'right' && 'hover-tilt-right',

                className
            )}
        >
            
            <div className='image'>
                <Image
                    src={src}
                    srcMedium={srcMobile}
                    alt={alt}
                    width={width}
                    sizes={sizes}
                />
            </div>

            <Mask
                bgColor='white'
                spacing={spacing}
                className='box'
            >

                <h3 className={clsx(
                    blockSize === 'large' && 'h2',
                    blockSize === 'medium' && 'h3',
                    blockSize === 'small' && 'h4'
                )}>
                    {title}
                </h3>

                <div
                    className={clsx(
                        'desc',
                        blockSize === 'large' && 'text-big',
                        blockSize === 'small' && 'text-small'
                    )}
                    dangerouslySetInnerHTML={{ __html: desc }}
                    suppressHydrationWarning
                />

                <AnimatedArrow className='arrow' />

            </Mask>

        </a>
    )
}